import React from "react";
import { Chip } from "@mui/material";
import { MimshakPensionService } from "../../../services/mimshakPensionService";
import { Product } from "../../../interfaces/DTO/mislaka_xml_models";
import { formatNumberFloor } from "../../../utils/namesFormater";

interface Props {
  products: Product[];
}

export const GuaranteedConversionFactorsChip: React.FC<Props> = ({ products }) => {
    const factors = MimshakPensionService.getUniqueGuaranteedConversionFactors(products);
    if (factors.length === 0) return null;
  
    const factorsText = factors.map(formatNumberFloor).join(", ");
  
    return <Chip label={`מקדם: ${factorsText}`} variant="outlined" />;
  };
  